import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";

const MODES = [
  {
    to: "/upload",
    tag: "01",
    title: "Upload My Reading",
    desc: "Bring your own PDF, TXT, or DOCX. We will surface vocabulary and questions tailored to your text.",
  },
  {
    to: "/library",
    tag: "02",
    title: "Public Domain Library",
    desc: "A small, deliberate collection: Plato, Marcus Aurelius, Frederick Douglass, Emerson, Darwin, and more.",
  },
  {
    to: "/generate",
    tag: "03",
    title: "AI Generated Reading",
    desc: "Original essays on Philosophy, Economics, History, Science, Civic Literacy, or Black Intellectual Tradition.",
  },
  {
    to: "/research",
    tag: "04",
    title: "Research Mentor",
    desc: "Investigate any topic. Map perspectives, identify evidence gaps, and learn to evaluate sources — without being told what to think.",
  },
];

export default function Learn() {
  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-5xl mx-auto px-6 lg:px-10 py-16 sm:py-24">
        <div className="text-[10px] tracking-[0.4em] uppercase text-ember-500 mb-4">Choose a path</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3" data-testid="learn-title">
          What will you read today?
        </h1>
        <p className="text-sm text-forge-100/60 mb-12 max-w-xl">
          Each path leads to the same loop: read, decode the language, answer probing questions, and reflect.
        </p>
        <div className="grid gap-px bg-white/5">
          {MODES.map((m) => (
            <Link
              key={m.to}
              to={m.to}
              className="block bg-forge-900 hover:bg-forge-800 p-8 sm:p-10 transition-all duration-300 group"
              data-testid={`learn-mode-${m.tag}`}
            >
              <div className="flex items-start gap-8">
                <div className="font-mono text-xs text-ember-500 mt-2">{m.tag}</div>
                <div className="flex-1">
                  <h2 className="font-serif text-2xl sm:text-3xl mb-3 group-hover:text-ember-400 transition-colors">{m.title}</h2>
                  <p className="text-sm sm:text-base text-forge-100/60 leading-relaxed max-w-2xl">{m.desc}</p>
                </div>
                <div className="text-2xl text-forge-100/30 group-hover:text-ember-500 group-hover:translate-x-1 transition-all">→</div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
